import { useEffect, useState } from "react";
import Button from "../elements/Button";
import InputField from "../elements/InputField";
import CustomSelect from "../elements/CustomSelect";

const SectionTranslateForm = ({
                                  section,
                                  languages,
                                  onCancel,
                                  onSave,
                              }) => {

    const [translations, setTranslations] = useState([]);

    useEffect(() => {
        setTranslations(
            section?.translations?.length
                ? section.translations.map(t => ({
                    language_id: t.language_id,
                    title: t.title || "",
                }))
                : []
        );
    }, [section]);

    const addTranslation = () => {
        setTranslations(prev => [
            ...prev,
            {
                language_id: "",
                title: "",
            },
        ]);
    };

    const updateTranslation = (index, key, value) => {
        setTranslations(prev =>
            prev.map((t, i) =>
                i === index
                    ? {
                        ...t,
                        [key]: value,
                    }
                    : t
            )
        );
    };

    const removeTranslation = (index) => {
        setTranslations(prev =>
            prev.filter((_, i) => i !== index)
        );
    };

    const save = async () => {
        const usedLanguages = new Set();

        for (const t of translations) {
            if (!t.language_id) {
                alert("زبان ترجمه را انتخاب کنید.");
                return;
            }

            if (!t.title.trim()) {
                alert("عنوان ترجمه نمی‌تواند خالی باشد.");
                return;
            }

            if (usedLanguages.has(String(t.language_id))) {
                alert("هر زبان فقط یک بار قابل انتخاب است.");
                return;
            }

            usedLanguages.add(String(t.language_id));
        }

        await onSave({
            section_id: section.id,
            translations,
        });
    };

    return (
        <div className="space-y-4">

            <div className="flex justify-between items-center">
                <h4 className="font-semibold">
                    ترجمه‌های سرفصل
                </h4>

                <Button
                    type="button"
                    onClick={addTranslation}
                    className="px-3 py-2 border rounded"
                >
                    <span>افزودن ترجمه</span>
                </Button>
            </div>

            {translations.length === 0 ? (
                <p className="text-sm text-gray-500">
                    هنوز ترجمه‌ای ثبت نشده است.
                </p>
            ) : (
                translations.map((translation, index) => (
                    <div
                        key={index}
                        className="border rounded-lg p-4 space-y-3"
                    >
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                            <CustomSelect
                                title="زبان"
                                value={translation.language_id}
                                options={languages.map(lang => lang.id)}
                                onChange={(e) =>
                                    updateTranslation(
                                        index,
                                        "language_id",
                                        e.target.value
                                    )
                                }
                            />

                            <InputField
                                title="عنوان"
                                value={translation.title}
                                onChange={(e) =>
                                    updateTranslation(
                                        index,
                                        "title",
                                        e.target.value
                                    )
                                }
                            />

                        </div>

                        <div className="flex justify-end">
                            <Button
                                type="button"
                                onClick={() => removeTranslation(index)}
                                className="px-3 py-2 border border-red-300 text-red-600 rounded"
                            >
                                <span>حذف</span>
                            </Button>
                        </div>
                    </div>
                ))
            )}

            <div className="flex justify-end gap-3 pt-2">

                <Button
                    onClick={onCancel}
                    className="px-4 py-2 border rounded"
                >
                    <span>انصراف</span>
                </Button>

                <Button
                    onClick={save}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                >
                    <span>ذخیره ترجمه‌ها</span>
                </Button>

            </div>

        </div>
    );
};

export default SectionTranslateForm;